import {
  BusinessModalName,
  BusinessModalNames,
  CorpBusinessAccount,
  CorpSessionInfo,
  ModalDataMap,
  PolicyTier,
  RewardsAccount,
  SessionInfo,
} from "redmond";
import {
  B2bBaseActions,
  SET_BUSINESS_ACCOUNTS,
  SET_MODAL_METADATA_INFO,
  SET_POLICY_TIER,
  SET_REWARDS_ACCOUNTS,
  SET_SELECTED_ACCOUNT_REFERENCE_ID,
  SET_SESSION_INFO,
} from "./actions";

export interface B2bBaseState {
  sessionInfo: SessionInfo | CorpSessionInfo | undefined;
  corpBusinessAccounts?: CorpBusinessAccount[];
  rewardsAccounts: RewardsAccount[];
  policyTier?: PolicyTier;
  selectedAccountReferenceId: string | null;
  modalMetadata: { [K in BusinessModalNames]?: ModalDataMap[K] } | null;
  hasSeenModalMap: Record<BusinessModalName, boolean> | null;
}

const initialState: B2bBaseState = {
  sessionInfo: undefined,
  corpBusinessAccounts: undefined,
  rewardsAccounts: [],
  policyTier: undefined,
  selectedAccountReferenceId: null,
  modalMetadata: null,
  hasSeenModalMap: null
};

export function rootReducer(
  state = initialState,
  action: B2bBaseActions,
): B2bBaseState {
  switch (action.type) {
    case SET_SESSION_INFO:
      return {
        ...state,
        sessionInfo: action.sessionInfo,
      };
    case SET_BUSINESS_ACCOUNTS:
      return {
        ...state,
        corpBusinessAccounts: action.businessAccounts,
      };
    case SET_REWARDS_ACCOUNTS:
      return {
        ...state,
        rewardsAccounts: action.rewardsAccounts,
      };

    case SET_SELECTED_ACCOUNT_REFERENCE_ID:
      return {
        ...state,
        selectedAccountReferenceId: action.selectedAccountReferenceId,
      };
    
    case SET_MODAL_METADATA_INFO:
      return {
        ...state,
        modalMetadata: action.metadata,
        hasSeenModalMap: action.hasSeenModalMap,
      };
    
    case SET_POLICY_TIER:
      return {
        ...state,
        policyTier: action.policyTier,
      };
    default:
      return state;
  }
}
